import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/invoices/templates/{id}']['PUT'];
type Input = ThisApi['params'] & ThisApi['body'];

const updateInvoiceTemplate = async ({ id, ...body }: Input): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.put(`/invoices/templates/${id}`, body);
  return response.data;
};

export default updateInvoiceTemplate;
